import Submit from "./submit";
import Table from "./table";
import {EvalFormat} from "./evalformat";

async function loadFromDomScript(queryDomElement) {
    const response = await Submit.submit(queryDomElement.innerText, "data/query");

    // get row formatter
    let rowFormatterScript = queryDomElement
        .parentNode
        .querySelector("script[type='row/formatter']")
        .innerText;

    // accessible within eval scripts
    let fmt = EvalFormat;

    let rowTransformer = eval("(" + rowFormatterScript + ")");

    let rows = [];
    response.rows.forEach((row) => {
        rows.push(rowTransformer(row));
    });

    // column headers can be specified on the script element and will be added to the table when specified
    let dataColumHeaders = queryDomElement.getAttribute("data-column-headers");
    if (dataColumHeaders != null) {
        dataColumHeaders = dataColumHeaders
            .split(",")
            .map(item => item.trim())
    } else {
        dataColumHeaders = [];
    }


    let contentBox = queryDomElement.closest(".content-box");
    let chartNoData = contentBox.querySelector(".chart-no-data");
    let table = contentBox.querySelector("table");
    if (rows.length === 0) {
        // display no data message
        chartNoData.style.display = "block";

        if (table != null)
            table.remove();
    } else {
        chartNoData.style.display = "none";
        Table.createTable(queryDomElement, rows, dataColumHeaders);
    }
}

const DashboardQuery = {
    "loadFromDomScript": loadFromDomScript
};

export default DashboardQuery;